import {
  ActivateUserRequest,
  VerifyUserActivationTokenResponse,
} from '@interfaces/users.interface';

import api from './';

export const { useVerifyUserActivationTokenQuery, useActivateUserMutation } =
  api.injectEndpoints({
    endpoints: (build) => ({
      verifyUserActivationToken: build.query<
        VerifyUserActivationTokenResponse,
        string
      >({
        query: (token) => ({
          url: `users/activate/${token}`,
          method: 'GET',
        }),
      }),
      activateUser: build.mutation<void, ActivateUserRequest>({
        query: ({ token, body }) => ({
          url: `users/activate/${token}`,
          method: 'POST',
          body,
        }),
      }),
    }),
  });
